
const get = (state) => state.sessions.list;
const isLoading = (state) => state.sessions.loading;
const isError = (state) => state.sessions.error;


export const SessionsSelectors = {
  get,
  isLoading,
  isError
}
